export const CollectionIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18.003" height="18" viewBox="0 0 18.003 18">
    <g data-name="Group 105567">
      <path
        data-name="Path 361952"
        d="M34 35H22a3 3 0 0 0-3 3 2.911 2.911 0 0 0 .052.552l1.44 7.676a2.616 2.616 0 0 0 2.569 2.131h9.883a2.616 2.616 0 0 0 2.569-2.131l1.44-7.676A2.91 2.91 0 0 0 37 38a3 3 0 0 0-3-3zm1.234 3.228L33.8 45.9a.869.869 0 0 1-.856.711h-9.885a.874.874 0 0 1-.859-.711l-1.44-7.673a1.236 1.236 0 0 1-.021-.227 1.256 1.256 0 0 1 1.254-1.254H34a1.261 1.261 0 0 1 1.234 1.486z"
        transform="translate(-19 -30.355)"
        style={{ fill: "#fff" }}
      />
      <path
        data-name="Path 361953"
        d="M39.484 19H27.871a.871.871 0 1 0 0 1.742h11.613a.871.871 0 0 0 0-1.742z"
        transform="translate(-24.677 -19)"
        style={{ fill: "#fff" }}
      />
    </g>
  </svg>
);
